import React from 'react';
import data from '../../legal-content/cookies.json';
import LegalDocument from '../../components/LegalDocument/LegalDocument';

const CookiesPolicyPage = () => <LegalDocument data={data} currentPage="CookiesPolicyPage" />;

export default CookiesPolicyPage;
